(function () {
  var COOKIE_NAME = 'mh_blog_list_return';
  var COOKIE_DAYS = 7;

  function getCookie(name) {
    var m = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
    return m ? decodeURIComponent(m.pop().trim()) : '';
  }

  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie =
      name +
      '=' +
      encodeURIComponent(value) +
      ';path=/;expires=' +
      d.toUTCString() +
      ';SameSite=Lax';
  }

  function isSameOriginUrl(url) {
    try {
      var u = new URL(url, window.location.origin);
      return u.origin === window.location.origin;
    } catch (e) {
      return false;
    }
  }

  function run() {
    var body = document.body;
    if (!body) return;

    var classes = body.classList;
    var isArticle = classes.contains('template--article');
    var isBlogListing = classes.contains('template--blog') && !isArticle;

    if (isBlogListing) {
      setCookie(COOKIE_NAME, window.location.href, COOKIE_DAYS);
      return;
    }

    if (!isArticle) return;

    var stored = getCookie(COOKIE_NAME);
    if (!stored || !isSameOriginUrl(stored)) return;

    document.querySelectorAll('[data-article-back-btn]').forEach(function (el) {
      el.setAttribute('href', stored);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
